module.exports = __webpack_public_path__ + "static/media/back-navy.00dfb821.png";